module.exports = __webpack_public_path__ + "media/images/logo-b6af540da94ace5db1deec33e1578ca5.png";